import { render, staticRenderFns } from "./MaterialsWinEdit.vue?vue&type=template&id=28a35fa4&scoped=true&"
import script from "./MaterialsWinEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialsWinEdit.vue?vue&type=script&lang=js&"
import style0 from "./MaterialsWinEdit.vue?vue&type=style&index=0&id=28a35fa4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a35fa4",
  null
  
)

export default component.exports